import React, { FC, useEffect, useState } from "react";

import firebase from "helpers/firebase";

import { GoogleSignIn } from "./buttons/GoogleSignIn";
import styles from "./styles.module.scss";
import { Link, useHistory } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import RequestFailed from "../../../../_components/RequestFailed";

export interface FederatedIdentitySignInFormProps {
  isRegistration?: boolean;
}

export const FederatedIdentitySignInForm: FC<FederatedIdentitySignInFormProps> =
  ({ isRegistration }) => {
    const history = useHistory();

    const [loading, setLoading] = useState(true);
    const [submissionError, setSubmissionError] = useState(false);

    useEffect(() => {
      firebase
        .auth()
        .getRedirectResult()
        .then((result) => {
          const { user } = result;
          setLoading(false);

          if (!user) {
            return;
          }

          history.push("/auth/finishSignIn");
        });
    }, []);

    if (loading) {
      return <Icon name="spinner" size="big" loading />;
    }

    if (submissionError) {
      return <RequestFailed onRetry={() => setSubmissionError(false)} />;
    }

    return (
      <div className={styles.federatedIDPList}>
        <GoogleSignIn isRegistration={isRegistration} />
        {isRegistration && (
          <div className="w-full">
            <p className="text-sm">
              By clicking on the sign up button above, you have agreed to our{" "}
              <Link to={"/terms"}>Terms and conditions</Link> and{" "}
              <Link to={"/privacy"}>Privacy policy</Link>.
            </p>
          </div>
        )}
      </div>
    );
  };
